// extracted by mini-css-extract-plugin
export default {"inline-code":"inline-code--dcdfcd","inlineCode":"inline-code--dcdfcd","inline-code_tiny":"inline-code_tiny--b6150f","inlineCode_tiny":"inline-code_tiny--b6150f"};